'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Button_web = require('../../atoms/Button/Button.web.cjs');
var Illustration_web = require('../../atoms/Illustration/Illustration.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var Link_web = require('../../molecules/Link/Link.web.cjs');
var EmptyState_web_styles = require('./EmptyState.web.styles.cjs');

/**
 * This component is used when there is no data to display, and guides the user on what to do next.
 *
 * {@link https://aviary.fullscript.io/latest/components/empty-state/web-srBuuzpY | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/organisms/EmptyState/EmptyState.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const EmptyState = ({ illustration: { illustration, intention = "neutral" }, title, description, variant = "noStyle", primaryAction, secondaryAction, link })=>{
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: [
            EmptyState_web_styles.container,
            variant === "card" && EmptyState_web_styles.card
        ],
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: EmptyState_web_styles.content,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(Illustration_web.Illustration, {
                        illustration: illustration,
                        intention: intention
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        variant: "h1",
                        isMarginless: true,
                        customCss: EmptyState_web_styles.title,
                        children: title
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        variant: "body",
                        isMarginless: true,
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: EmptyState_web_styles.actions,
                children: [
                    (primaryAction || secondaryAction) && /*#__PURE__*/ jsxRuntime.jsxs("div", {
                        css: EmptyState_web_styles.buttons,
                        children: [
                            secondaryAction && /*#__PURE__*/ jsxRuntime.jsx(Button_web.Button, {
                                ...secondaryAction,
                                variant: "secondary"
                            }),
                            primaryAction && /*#__PURE__*/ jsxRuntime.jsx(Button_web.Button, {
                                ...primaryAction,
                                variant: "primary"
                            })
                        ]
                    }),
                    link && /*#__PURE__*/ jsxRuntime.jsx(Link_web.Link, {
                        ...link
                    })
                ]
            })
        ]
    });
};

exports.EmptyState = EmptyState;
//# sourceMappingURL=EmptyState.web.cjs.map
